import type { ContratProDTO } from '@/features/api/extranet/dto/Demande/CPRO'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared'

export const getNaturesFichiersCpro: NaturesFichiersDemandeCallback<ContratProDTO> = (demande, typeContext) => {
  let obligatoires = ['Cerfa']
  let facultatifs = ['Autre', 'ProtocoleIndividuelFormationFOAD']
  let facultatifsDefaut: string[] = []

  const existsFormationInterne = demande.formation?.modules?.some((x) => x.typeModule === 'Interne')
  const nbModule = demande.formation?.modules?.length ?? 0
  const nbFormationExterne = demande.formation?.modules?.filter((x) => x.typeModule === 'Externe').length ?? 0

  switch (demande.sousDispositif) {
    case 'ContratProfessionnalisation': {
      if (nbFormationExterne) obligatoires.push('Convention')

      obligatoires.push('Programme')
      if (
        ['3043', '0573'].includes(demande.employeur!.etablissement!.idcc!.code) &&
        demande.formation?.typeQualification === 'Cqp'
      )
        obligatoires.push('ConventionBilanEvaluation')

      if (existsFormationInterne) {
        obligatoires.push('Calendrier')
        obligatoires.push('AttestationFormateurInterne')
      }
      break
    }
    case 'Prodiat': {
      if (nbFormationExterne > 1) obligatoires.push('Convention')
      obligatoires.push('ConventionEntrepriseOFA')

      if (existsFormationInterne) {
        obligatoires.push('AttestationFormateurInterne')
      }

      obligatoires.push('CVBeneficiaire')
      obligatoires.push('ExtraitClassificationCCNVisee')
      break
    }
  }

  if (typeContext === TypesContextesAutorisesEnum.Prestataire) {
    facultatifs = [...obligatoires, ...facultatifs]
    facultatifsDefaut = [...obligatoires, ...facultatifsDefaut]
    obligatoires = []
  }

  return {
    obligatoires: obligatoires,
    facultatifs: facultatifs,
    facultatifsDefaut: facultatifsDefaut,
    /* Si absent, prend valeur par défaut. Peut-etre calculé. Exemple :
        {
            'Cerfa': 10,
            'Convention': 2
        }
    */
    nombreFichiersMaximum: {},
    nombreFichiersMinimum: {
      Convention: nbFormationExterne,
      Programme: nbModule,
    },
  }
}
